function ContextMenuProvider({ children, isOpen }) {
  return isOpen ? children : null;
}

export default ContextMenuProvider;
